import * as React from 'react';
import { useAppSelector } from 'src/store/hooks';

const ImvReport: React.FunctionComponent<any> = () => {
  const showCMPArr: any = useAppSelector(state => state.imvReport.showCMPArr);
  return (
    <>
      {showCMPArr.map((ele: any) => (
        <>{ele.curruntlyActive ? <ele.cmp item={ele} /> : null}</>
      ))}
    </>
  );
};
export default ImvReport;
